import React from 'react';
import styles from './Attendee.module.css';
import DefaultProfileImg from '../../../../shared/project-info/images/DefaultProfileImg.png';
import AppMark from '../../../../shared/project-info/web-project-info/svgs/AppMark';
import {projectConfig} from '../../../../shared/project-info/projectConfig';

const EventHost = ({item, onSelect}) => {
  const {profile_photo_url, first_name, last_name, leader, title} = item;
  return (
    <div className={styles.container} style={{backgroundColor: 'var(--grey8)'}} onClick={onSelect}>
      <div className={styles.imgContainer}>
        <img src={!profile_photo_url ? DefaultProfileImg : profile_photo_url} className={styles.img} alt={'User profile'} />
      </div>
      <div className={styles.labelContainer}>
        <div>
          <h3>{`${first_name} ${last_name}`}</h3>
          {/* {is_eagle_leader && <AppMark width={40} height={15} />} */}
        </div>
        {leader ? (
          <>
            <h5>{projectConfig.leaderRoleDisplay}</h5>
            <h5>{title}</h5>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default EventHost;
